import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import _ from 'lodash';
import SelectField, { mapOptionsToSelectField } from '../../../shared-components/SelectField/SelectField';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';
import { Field } from 'redux-form';

const LOCALE_PREFIX = 'GB/components/FinancialInfo/FinancialInfo';

export class MonthlyExpenses extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        monthlyExpensesListOptions: PropTypes.object.isRequired,
        financialInfo: PropTypes.object.isRequired
    };

    render() {
        const { intl, monthlyExpensesListOptions, financialInfo } = this.props;

        return (
            <Field
                id="monthlyLivingExpenses"
                name="monthlyLivingExpenses"
                component={SelectField}
                optionList={mapOptionsToSelectField(monthlyExpensesListOptions)}
                required={true}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.livingExpenses`})}
                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.livingExpenses`})}
                validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.livingExpenses-empty`}))]}
            />
        );
    }
}

export const mapStateToProps = state => ({
    monthlyExpensesListOptions: _.get(state, `serverData.messages[${LOCALE_PREFIX}].applyForBmlUK.incomeRange`),
    financialInfo: _.get(state, 'form.ppcreditapply.values.financial-info')
});

export default connect(mapStateToProps)(injectIntl(MonthlyExpenses));
